(() => {
  const config = {
    helmets: ['[data-helmet-shop]', '[data-hs-filter="brand"]', '#HelmetCatalog'],
    tires: ['[data-tire-shop]', '[data-ts-filter="brand"]', '#TireCatalog'],
    gear: ['[data-gear-brand]', '[data-gear-brand]', '#GearCatalog'],
    parts: ['[data-supplier-catalog][data-department="parts"] [data-sc-brand]', '[data-sc-brand]', '#DepartmentCatalog'],
    accessories: ['[data-supplier-catalog][data-department="accessories"] [data-sc-brand]', '[data-sc-brand]', '#DepartmentCatalog'],
    exhaust: ['[data-ex-brand-options]', '[data-ex-brand]', '#ExhaustCatalog']
  };
  function boot() {
    for (const root of document.querySelectorAll('[data-category-brands]')) {
      if (root.dataset.ready) continue;
      const [watchSelector, controlSelector, anchor] = config[root.dataset.categoryBrands] || [];
      const source = document.querySelector(watchSelector);
      if (!source) continue;
      root.dataset.ready = 'true';
      const picker = root.querySelector('select'), empty = picker.options[0].textContent;
      const controls = () => source.matches('select') ? [source] : [...source.querySelectorAll(controlSelector)];
      function sync() {
        const fields = controls(), select = fields[0]?.matches('select') ? fields[0] : null;
        const values = select ? [...select.options].filter(o => o.value).map(o => [o.value,o.value]) : fields.map(f => [f.value,f.value]);
        const selected = select ? select.value : fields.find(f => f.checked)?.value || '';
        const signature = JSON.stringify(values);
        if (picker.dataset.signature !== signature) {
          picker.replaceChildren(new Option(empty,''),...values.sort((a,b)=>a[1].localeCompare(b[1])).map(([value,label])=>new Option(label,value)));
          picker.dataset.signature = signature;
        }
        picker.value = selected;
        picker.disabled = !values.length;
      }
      picker.addEventListener('change', () => {
        const wanted = picker.value;
        const fields = controls(), select = fields[0]?.matches('select') ? fields[0] : null;
        if (select) {select.value=wanted;select.dispatchEvent(new Event('change',{bubbles:true}));}
        else if(root.dataset.categoryBrands==='exhaust'){
          for(const field of fields){if(field.checked){field.checked=false;field.dispatchEvent(new Event('change',{bubbles:true}));}}
          const match=fields.find(f=>f.value===wanted);if(match){match.checked=true;match.dispatchEvent(new Event('change',{bubbles:true}));}
        }
        else {fields.forEach(f=>f.checked=f.value===wanted);fields[0]?.dispatchEvent(new Event('change',{bubbles:true}));}
        document.querySelector(anchor)?.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        sync();
      });
      new MutationObserver(sync).observe(source,{childList:true,subtree:true});
      source.addEventListener('change',sync);
      sync();
    }
  }
  boot();document.addEventListener('shopify:section:load',boot);
})();
